<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title class="ion-text-center header-title">{{ 'HELP.TITLE' | translate }}</ion-title>

      <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/']" replaceUrl class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>

       <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<ion-content>
  <ion-grid fixed class="ion-padding">
    <ion-row>
      <ion-col class="info">

        <h1 class="info__title">{{ 'HELP.DO_YOU_HAVE_PROBLEMS' | translate }}</h1>

        <p class="info__content">{{ 'HELP.WE_WOULD_LOVE_TO_HELP' | translate }}</p>
        
        <p class="info__content">{{ 'HELP.SEND_EMAIL' | translate }} <a href="mailto:podpora@table42.app">podpora@table42.app</a>{{ 'HELP.SEND_EMAIL_AFTER' | translate }} {{ 'HELP.CALL' | translate }} <a href="tel:+38631312039"><span *ngIf="translateService.currentLang == 'sl'">0</span><span *ngIf="translateService.currentLang !== 'sl'">+386 </span>31 312 039</a>{{ 'HELP.CALL_AFTER' | translate }}.</p>

        <p class="info__content">{{ 'HELP.WE_WILL_TRY' | translate }}</p>

      </ion-col>

    </ion-row>
  </ion-grid>
 
</ion-content>